import _ from "lodash";
import * as z from "../../../framework";
import { logout } from "../core";

export var Enabled = $(document.head).data("realTimeUpdatesEnabled") || false;

var urlWithTrailingSlash;
var connection;
var disconnectEvents: (() => void)[] = [];
var reconnectEvents: (() => void)[] = [];
var reconnectIntervalTime: number = 60000; // 1 minute

export function url() {
    if (urlWithTrailingSlash == undefined) {
        let realTimeUpdateUrl = $(document.head).data("realTimeUpdateUrl");
        let lastChar = realTimeUpdateUrl[realTimeUpdateUrl.length - 1];
        if (lastChar != "/") {
            realTimeUpdateUrl += "/";
        }

        urlWithTrailingSlash = realTimeUpdateUrl;
    }

    return urlWithTrailingSlash;
}

export function logIfDebuggerAttached(message) {
    if (!window.z.debuggerAttached) {
        return;
    }
    if (!message) {
        return;
    }

    console.log(message);
}

export function registerCodeDataSource(uiElement, codeName: string, args?) {
    args = args || {};

    var codes = z.deepClone(z.codes[codeName]);
    if (args.additionalCodes) {
        codes.unshift(...args.additionalCodes);
    }

    if (args.filter) {
        codes = _.filter(codes, args.filter);
    }

    var kendoComboBox = uiElement.data("kendoComboBox");
    kendoComboBox && kendoComboBox.setDataSource(codes);

    if (Enabled && kendoComboBox) {
        z.events.register(`CODE:${codeName}`, function () {
            var filteredCodes = z.deepClone(z.codes[codeName]);
            if (args.additionalCodes) {
                filteredCodes.unshift(...args.additionalCodes);
            }

            if (args.filter) {
                filteredCodes = _.filter(codes, args.filter);
            }

            kendoComboBox.setDataSource(filteredCodes);
        });
    }
}

export function generateConnection() {
    var conn = ($ as any).hubConnection();
    conn.url = `${url()}signalr`;

    conn.qs = {
        "Authorization-Token": z.getToken(),
        "CompanyId": z.settings.CompanyId
    };

    return conn;
}

export function updateSessionCodes() {
    z.setLocalStorage("codes", JSON.stringify(z.codes));
}

export function addListeners(args) {
    var proxy = connection.proxies.serviceprohub;

    if (args.pullAppointment) {
        proxy.on("PullAppointment", args.pullAppointment);
    }

    if (args.deleteAppointment) {
        proxy.on("DeleteAppointment", args.deleteAppointment);
    }

    if (args.pullServiceTech) {
        proxy.on("PullServiceTech", args.pullServiceTech);
    }

    if (args.deleteServiceTech) {
        proxy.on("DeleteServiceTech", args.deleteServiceTech);
    }

    if (args.pullEmployee) {
        proxy.on("PullEmployee", args.pullEmployee);
    }

    if (args.deleteEmployee) {
        proxy.on("DeleteEmployee", args.deleteEmployee);
    }
}

export function openConnection(args?) {
    if (!Enabled) {
        return undefined;
    }

    args = args || {};
    var proxy;

    var establishInitialConnection = connection == null;
    if (establishInitialConnection) {
        connection = generateConnection();
        proxy = connection.createHubProxy("serviceProHub");
    }

    addListeners(args);

    if (!establishInitialConnection) {
        return connection;
    }

    proxy.on("PullCode", function (correlationId, correlationGroupId, codeCategory, id, userId) {
        z.ajax({
            type: "GET",
            url: `${codeCategory}/${id}`,
            correlationId: correlationId,
            correlationGroupId: correlationGroupId,
            errorHandled: true
        }).done(function (response) {
            z.codes[codeCategory] = $.grep(z.codes[codeCategory], function (code) {
                return code.Id != id;
            });

            z.codes[codeCategory].push(response.d.results);
            z.events.fire(`CODE:${codeCategory}`);
            updateSessionCodes();

            logIfDebuggerAttached(`RealTimeUpdates Updated ${codeCategory} with id of ${id}.`);
        });
    });

    proxy.on("DeleteCode", function (correlationId, correlationGroupId, codeCategory, id, userId) {
        var codeIndex = _.findIndex(z.codes[codeCategory], { Id: id });
        var code = z.codes[codeCategory][codeIndex];
        if (!code) {
            return;
        }

        code.IsDeleted = true;

        z.codes[codeCategory].splice(codeIndex, 1);
        z.codes[codeCategory].push(code);

        if (userId != z.user.loginData.UserId) {
            z.controls.alert({
                header: z.ll("CodeDeleted").format(codeCategory),
                message: z.ll("CodeDeletedByAnotherUser").format(codeCategory, code.CodeNumber),
                type: "warning"
            });
        }

        z.events.fire(`CODE:${codeCategory}`);
        updateSessionCodes();

        logIfDebuggerAttached(`RealTimeUpdates Deleted ${codeCategory} with id of ${id}.`);
    });

    proxy.on("disconnect", function (err) {
        connection.stop();
        if (err === "unauthorized") {
            logIfDebuggerAttached("RealTimeUpdates Connection Unauthorized.");
            logout(true);
        }
        connection.status = "disconnected";
        _.forEach(disconnectEvents, (event) => event());
        logIfDebuggerAttached("RealTimeUpdates Connection Stopped.");
        startReconnectHandler();
    });

    connection.disconnected(() => {
        if (connection.status === "connected") {
            connection.stop();
            connection.start().fail(() => {
                connection.status = "disconnected";
                _.forEach(disconnectEvents, (event) => event());
                logIfDebuggerAttached("RealTimeUpdates Connection Stopped.");
                startReconnectHandler();
            });
        }
    });

    connection.status = "connecting";
    connection.start().done(function () {
        connection.status = "connected";
        logIfDebuggerAttached("RealTimeUpdates Connection Started.");
    }).fail(function () {
        connection.status = "disconnected";
        _.forEach(disconnectEvents, (event) => event());
        startReconnectHandler();
    });

    return connection;
}

export function getConnection() {
    return connection;
}

export function onDisconnect(event: () => void) {
    disconnectEvents.push(event);
}

export function onReconnect(event: () => void) {
    reconnectEvents.push(event);
}

function startReconnectHandler() {
    connection.status = "connecting";
    connection.start().done(() => {
        connection.status = "connected";
        logIfDebuggerAttached("RealTimeUpdates Connection Started.");
        _.forEach(reconnectEvents, (event) => event());
    }).fail(() => {
        connection.status = "disconnected";
        let intervalId = setInterval(() => {
            connection.status = "connecting";
            connection.start().done(() => {
                connection.status = "connected";
                clearInterval(intervalId);
                logIfDebuggerAttached("RealTimeUpdates Connection Started.");
                _.forEach(reconnectEvents, (event) => event());
            }).fail(() => {
                connection.status = "disconnected";
            });
        }, reconnectIntervalTime);
    });
}
